import axios from "axios";
import { IAccountForm, IProcessorFiatRange } from "../types";
import { getLogout } from "src/helpers/mixins";

//export const endPoint =  "http://132.148.74.56:5555"
export const endPoint =
  process.env.REACT_APP_API || "http://132.148.74.56:5555";
export interface IOptionalActivityRequest {
  activity: string;
  traveler: string;
  booking: string;
}
export interface IUserRegisterBody {
  email: string;
  phone: string;
  password: string;
  country: string;
  role?: string
  cashierFather?: string
}
export interface IUserLoginBody {
  email: string;
  password: string;
}
export interface IAccountList {
  user?: string;
  cashier?: string;
}
export interface IAccountRemove {
  account: string;
}
export interface IRemoveById {
  id: string | number;
}
export interface IDetailById {
  id: string | number;
}
export interface IUserEdit {
  userid: string;
  fullname: string;
  email: string;
  birthday: string;
  phone: string;
  country: string;
}
export interface IFiatCreate {
  name: string;
  price: string;
  symbol: string;
}
export interface IFiatEdit {
  id: string;
  name: string;
  price: string;
  symbol: string;
}
export interface IProcessorForm {
  id?: string;
  name: string;
  paymentmethod: boolean;
  type: string;
  photoUrl?: string;
  isMobileBankAccount: boolean;
}
export interface ItransferCalculate {
  money: string;
  origen: string | number
  destiny: string | number
  cashierId: string 
  currentusd?: string | number
  destinyFiatName?: string
  origenFiatName?: string
}
export interface ITransferCreate {
  user: string;
  money: string;
  percenthouse: string;
  percentcashier: string;
  profithouse: string;
  currentusd: string;
  profitcashier: string;
  totaltopay: string | undefined;
  currency: string;
  derivtitular: string;
  derivcr: string;
  processor?: string | number | undefined;
}
 

export interface IUpdateStatus {
  id: string;
  status: string;
}

/* export interface IUserUploadPayment {
  id: string;
  file: File;
} */

export interface ICreateNotification {
  message: string;
  userId: string | number;
  type?: string;
  typeId?: string | number;
  link?: string;
}
export interface IListNotification {
  userId: string | number | undefined;
  skip: number;
}
interface IAPIService {
  //getToken(body: IOptionalActivityRequest[]): Promise<any | undefined>
  getToken(): Promise<any | undefined>;
  userRegister(body: IUserRegisterBody): Promise<any | undefined>;
  userLogin(body: IUserLoginBody): Promise<any | undefined>;
  userRecoverAccount(body: any): Promise<any | undefined>;
  userVerifyRecoverAccountCode(body: any): Promise<any | undefined>;
  transferUploadManyFiles(body: any): Promise<any | undefined>;
  kycEmailNotification(body: any): Promise<any | undefined>
  transferAccelerate(body: any): Promise<any | undefined>

  accountList(body: IAccountList): Promise<any | undefined>;
  userAccountCreate(body: any): Promise<any | undefined>;
  accountRemove(body: IAccountRemove): Promise<any | undefined>;
  accountEdit(body: IAccountForm): Promise<any | undefined>;
  userEdit(body: IUserEdit ): Promise<any | undefined>;
  
  userSetFullname(body: any ): Promise<any | undefined>;
  processorCreate(body: IProcessorForm): Promise<any | undefined>;
  processorEdit(body: IProcessorForm): Promise<any | undefined>;
  processorList(body: any): Promise<any | undefined>;
  processorRemove(body: IRemoveById): Promise<any | undefined>;
  processorUpdateStatus(body: IUpdateStatus): Promise<any | undefined>;
  fiatCreate(body: IFiatCreate): Promise<any | undefined>;
  fiatList(body: any): Promise<any | undefined>;
  fiatEdit(body: IFiatEdit): Promise<any | undefined>;
  fiatRemove(body: IRemoveById): Promise<any | undefined>;
  processorFiatRangeCreate(body: IProcessorFiatRange): Promise<any | undefined>;
  processorFiatRangeEdit(body: IProcessorFiatRange): Promise<any | undefined>;
  processorFiatRangeRemove(body: IRemoveById): Promise<any | undefined>;
  processorFiatRangeList(body: any): Promise<any | undefined>;
  transferCalculate(body: ItransferCalculate): Promise<any | undefined>;
  TransferCreate(body: ITransferCreate): Promise<any | undefined>;
  derivListDeposit(body: IAccountList): Promise<any | undefined>;
  derivListDepositWait(body: IAccountList): Promise<any | undefined>;
  depositDetail(body: any): Promise<any | undefined>;

  depositUploadEvidence(body: any): Promise<any | undefined>;
  depositListAnyPic(body: any): Promise<any | undefined>;
  depositOpinionDetail(body: any): Promise<any | undefined>;
  depositOpinionSave(body: any): Promise<any | undefined>;
  derivCheckAccount(body: any): Promise<any | undefined>;
  accountBankUpdateRemove(body: IRemoveById): Promise<any | undefined>;
  /* userUploadPayment(body: IUserUploadPayment): Promise<any | undefined>; */
  userDetailVerification(body: any): Promise<any | undefined>;
  chatCreateMessage(body: any): Promise<any | undefined>;
  chatListMessage(body: any): Promise<any | undefined>;
  notificationCreate(body: ICreateNotification): Promise<any | undefined>;
  notificationList(body: IListNotification): Promise<any | undefined>;
  activateVerifyAccount(body: any): Promise<any | undefined>;
  sendEmailVerifyAccount(body: any): Promise<any | undefined>;
  userUpdatePassword(body: any): Promise<any | undefined>;

  webBlogList(body: any): Promise<any | undefined>;
  updateIsOnline(body: any): Promise<any | undefined>;
  listUserChat(body: any): Promise<any | undefined>;
  fetchCurrentDollar(body: any): Promise<any | undefined>;
  fetchFreeDollar(body: any): Promise<any | undefined>;
  /*userNotificationSeen(body:any):Promise<any | undefined>*/
  userRoleList(body: any): Promise<any | undefined>;
  userRoleUpdate(body: any): Promise<any | undefined>;
  userNotificationDelete(body: any): Promise<any | undefined>;
  getUserInfo(body: any): Promise<any | undefined>;
  adminNotificationRead(body: any): Promise<any | undefined>;
  userNotificationRead(body: any): Promise<any | undefined>;
  userAddUpdateValidation(body: any): Promise<any | undefined>; 
  userCheckVerifiedIdentity(body: any): Promise<any | undefined>
  userGetQuantities(body: any): Promise<any | undefined>
  userFindMyCashier(body: any): Promise<any | undefined>
  userChooseCashierList(body: any): Promise<any | undefined>
  userNotifyScheduleSave(body: any): Promise<any | undefined>
  userChooseCashierSet(body: any): Promise<any | undefined>
  userUploadProfilePicture(body: any): Promise<any | undefined>
  userCreateAppeal(body: any): Promise<any | undefined>
  userGetCompletedTransfers(body: any): Promise<any | undefined>
  updateLastConnection(body: any): Promise<any | undefined>
  //system
  systemVerifyCashierApodo(body: any): Promise<any | undefined>;
  systemLoginHistory(body: any): Promise<any | undefined>;
  systemAppealList(body: any): Promise<any | undefined>
  systemUserDetail(body: any): Promise<any | undefined>;
  systemDepositUpdateStatus(body: any): Promise<any | undefined>;
  systemViewNotifications(body: any): Promise<any | undefined>;
  systemDispatchCronCancel(body: any): Promise<any | undefined>;

  //admin
  adminDepositList(body: any): Promise<any | undefined>;
  adminDepositListSearch(body: any): Promise<any | undefined>;
  adminUserExamined(id: string, startDate: string, endDate: string, bank: string, status: string): Promise<any | undefined>;
  adminDepositDetail(body: IDetailById): Promise<any | undefined>;
  adminDepositTimeGet(body: any): Promise<any | undefined>;
  adminDepositTimeSave(body: any): Promise<any | undefined>;
  adminUserList(body: any): Promise<any | undefined>;
  adminUserListVerification(body: any): Promise<any | undefined>;
  adminReadNotification(body: any): Promise<any | undefined>
  adminNotificationDelete(body: any): Promise<any | undefined>
  adminSearchChatUser(body: any): Promise<any | undefined>
  adminBlogCreateEdit(body: any): Promise<any | undefined>;
  adminBlogList(body: any): Promise<any | undefined>;
  adminBlogUpdateStatus(body: IUpdateStatus): Promise<any | undefined>;
  adminBlogRemove(body: IRemoveById): Promise<any | undefined>;
  adminUserUpdateStatus(body: any): Promise<any | undefined>; 
  adminReports(body: any): Promise<any | undefined>;
  adminReportsProcessors(body: any): Promise<any | undefined>;
  adminUpdateVerification(body: any): Promise<any | undefined>;
  adminRemoveSomePic(body: any): Promise<any | undefined>;
  adminUpdateVerifiedIdentity(body: any): Promise<any | undefined>
  adminProcessorSetFiat(body:any): Promise<any | undefined>
  adminProfitList(body:any): Promise<any | undefined>
  adminProfitSave(body:any): Promise<any | undefined>
  adminProfitDelete(body:any): Promise<any | undefined>
  AdminOpinionList(body:any): Promise<any | undefined>
  AdminOpinionStatusUpdate(body:any): Promise<any | undefined>
  AdminRequestCoinsList(body:any): Promise<any | undefined>
  AdminAccountPayCoinsSave(body:any): Promise<any | undefined>
  AdminAccountPayCoinsList(body:any): Promise<any | undefined>
  AdminAccountPayCoinsDelete(body:any): Promise<any | undefined>
  AdminAccountPayCoinsUpdateStatus(body:any): Promise<any | undefined>
  AdminRequestCoinsUpdateStatus(body:any): Promise<any | undefined>
  AdminSetCoinsCashier(body:any): Promise<any | undefined>
  AdminUserListLoggins(body:any): Promise<any | undefined>
  AdminAppealFinish(body:any): Promise<any | undefined>
  AdminGetHouseCoins(body:any): Promise<any | undefined>
  AdminGetHouseCoinsMovements(body:any): Promise<any | undefined>
  AdminAllCashierCoins(body:any): Promise<any | undefined>
  AdminGetISFWeltradeBalance(body:any): Promise<any | undefined>
  AdminWeltradeUpdateBalanceByAdmin(body:any): Promise<any | undefined>
  AdminGetUpscaleBalanceSummary(): Promise<any | undefined>
  AdminGetUpscaleBalanceDetail(body: { environment: string; scope?: string }): Promise<any | undefined>
  AdminGetUpscaleTransferMap(depositId: string): Promise<any | undefined>
  AdminGetUpscaleTransferDetailByExternal(externalId: string): Promise<any | undefined>
  AdminUpscaleUpdateBalanceByAdmin(body: { environment: string; balance: string }): Promise<any | undefined>
  AdminUpscaleRunBalanceCron(): Promise<any | undefined>
  AdminWeltradeBalanceHistory(body:any): Promise<any | undefined>
  AdminWeltradeVerifyBalanceByDate(body:any): Promise<any | undefined>
  AdminSendEmail(body:any): Promise<any | undefined>
  //cashier
  cashierListProcessors(body: any): Promise<any | undefined>
  calculatorListProcessors(body: any): Promise<any | undefined>
  cashierSwitchProcessors(body: any): Promise<any | undefined>
  cashierListProcessorsRange(body: any): Promise<any | undefined>
  cashierSaveProcessorsRange(body: any): Promise<any | undefined>
  cashierDetail(body: any): Promise<any | undefined>
  cashierSearchClient(body: any): Promise<any | undefined>
  cashierChangeClient(body: any): Promise<any | undefined> 
  CashierCoinsRequestSave(body:any): Promise<any | undefined> 
  CashierCoinsRequestList(body:any): Promise<any | undefined> 
  CashierCoinsRequestCancel(body:any): Promise<any | undefined> 
  CashierCoinsRequestDetail(body:any): Promise<any | undefined> 
  CashierCoinsUploadPayment(body:any): Promise<any | undefined> 
  CashierCoinsGetPics(body:any): Promise<any | undefined> 
  CashierConfigGet(body:any): Promise<any | undefined> 
  CashierWelcomeGet(body:any): Promise<any | undefined> 
  CashierWelcomeUpdate(body:any): Promise<any | undefined> 
  CashierNicknameSave(body:any): Promise<any | undefined> 
  CashierDescriptionTime(body:any): Promise<any | undefined> 
  CashierByApodo(body:any): Promise<any | undefined> 
  CashierGetReviews(body:any): Promise<any | undefined> 
  CashierListTransfer(body:any): Promise<any | undefined> 
  CashierOpinions(body:any): Promise<any | undefined> 
  CashierGetCoins(body:any): Promise<any | undefined> 
  CashierGetAccountPayCoins(body:any): Promise<any | undefined> 
  cashierAccountCreate(body: any): Promise<any | undefined>;
  cashierAccountEdit(body: any): Promise<any | undefined>;
  cashierAccountList(body: any): Promise<any | undefined>;
  cashierAccountRemove(body: any): Promise<any | undefined>;
  cashierGetSchedule(body: any): Promise<any | undefined>;
  cashiertSaveSchedule(body: any): Promise<any | undefined>;
  cashierGetSocialNetwork(body: any): Promise<any | undefined>;
  cashierSaveSocialNetwork(body: any): Promise<any | undefined>;
  cashierAccountBankUpdateStatus(body: IUpdateStatus): Promise<any | undefined>;
  cashierCoinsMovements(body: any): Promise<any | undefined>;
  cashierGetFiatPrices(body: any): Promise<any | undefined>;
  cashierUpdateFiatPrices(body: any): Promise<any | undefined>;
  cashierUpdateFiatPricesNavbar(body: any): Promise<any | undefined>;
  cashierSearchTransfer(body: any): Promise<any | undefined>;
  chatTransferSaveMessage(body: any): Promise<any | undefined>;
  chatTransferListMessage(transferId: any): Promise<any | undefined>;
  findChatId(transferId: any): Promise<any | undefined>;
  notifyUserWannaBeCashier(body: any): Promise<any | undefined>;
  adminSaveVideo(body: any): Promise<any | undefined>;
  adminUpdateImageVideo(body: any): Promise<any | undefined>;
  videoList(body: any): Promise<any | undefined>;
  getVideoPromotional(body: any): Promise<any | undefined>;
  fetchtWall(body: any): Promise<any | undefined>;
  videoUpdateStatus(body: any): Promise<any | undefined>;
  videoUpdateName(body: any): Promise<any | undefined>;
  videoUpdateViews(body: any): Promise<any | undefined>;
  videoLike(body: any): Promise<any | undefined>;
  videoDelete(body: any): Promise<any | undefined>;
  videoPromotionalSectionSave(body: any): Promise<any | undefined>;
  videoPromotionalSectionList(body: any): Promise<any | undefined>;
  videoPromotionalCodeSave(body: any): Promise<any | undefined>;
  videoPromotionalCodeList(body: any): Promise<any | undefined>;
  completeFastRegister(body: any): Promise<any | undefined>;
  upscaleCompleteFastRegister(body: any): Promise<any | undefined>;
  transferResume(body: any): Promise<any | undefined>;
  upscaleTransferResume(body: { externalId: string }): Promise<any | undefined>;
  weltradeLoginSecureUser(body: any): Promise<any | undefined>;
  weltradeGetPayment(body: any): Promise<any | undefined>;
  weltradeSavePayment(body: any): Promise<any | undefined>;


  AppMobileSignalCreate(body: any): Promise<any | undefined>;
  AppMobileProviderSignalList(body: any): Promise<any | undefined>;
  AppMobileProviderList(body: any): Promise<any | undefined>;
  AppMobileProviderSubscribersList(body: any): Promise<any | undefined>;
  AppMobileProviderByDetail(body: any): Promise<any | undefined>;
  AppMobileProviderSignalDelete(body: any): Promise<any | undefined>;
  AppMobileSignalsGeneralFeed(body: any): Promise<any | undefined>;
  AppMobileSusbcribersList(body: any): Promise<any | undefined>;
  AppMobileSignalUploadImage(body: any): Promise<any | undefined>;
  AppMobileSignalIA(body: any): Promise<any | undefined>;

  WebappGetNotificationSettings(body: { token: string }): Promise<any | undefined>;
  WebappUpdateNotificationSettings(body: {
    token: string;
    emailOnSignalCreate?: boolean;
    emailOnSignalUpdate?: boolean;
    pushOnSignalCreate?: boolean;
    pushOnSignalUpdate?: boolean;
    email?: boolean;
    push?: boolean;
    sms?: boolean;
  }): Promise<any | undefined>;
  WebappUnsubscribeEmailSignals(body: { token: string }): Promise<any | undefined>;
  RequestDeleteAccount(body: { email: string }): Promise<any | undefined>;
  ConfirmDeleteAccount(body: { email: string; code: string }): Promise<any | undefined>;

  AdminGetUserNotificationSettings(body: {
    email?: string;
    userId?: string;
  }): Promise<any | undefined>;
  AdminUpdateUserNotificationSettings(body: {
    email?: string;
    userId?: string;
    emailOnSignalCreate?: boolean;
    emailOnSignalUpdate?: boolean;
    pushOnSignalCreate?: boolean;
    pushOnSignalUpdate?: boolean;
    push?: boolean;
    sms?: boolean;
  }): Promise<any | undefined>;
  AdminGetUserDevices(body: {
    email?: string;
    userId?: string;
  }): Promise<any | undefined>;


  chatGTPImage(body: any): Promise<any | undefined>;
  chatGTPGenerateAudio(body: any): Promise<any | undefined>;
  
}

const accessToken = () => localStorage.getItem("accessToken") || "";
const authToken = () => localStorage.getItem("authToken") || "";

const APIService: IAPIService = {
  getToken: async (): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
        url: `${endPoint}/v1/isf/generate-access-token`,
        //data: body
      })
        .then((res) => {
          const {
            data: { data },
          } = res;
          localStorage.setItem("accessToken", data?.accessToken);
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userRegister: async (body: IUserRegisterBody): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/user/register`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userLogin: async (body: IUserLoginBody): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/user/login`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  accountList: async (body: IAccountList): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/account-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userAccountCreate: async (body: IAccountForm): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/account-create`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  accountRemove: async (body: IAccountRemove): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/account-remove`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  accountEdit: async (body: IAccountForm): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/account-edit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userEdit: async (body: IUserEdit): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/user-edit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userSetFullname: async (body: IUserEdit): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/user-set-fullname`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  processorCreate: async (body: IProcessorForm): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/processor-create`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  processorEdit: async (body: IProcessorForm): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/processor-edit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  transferResume: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/weltrade/transfer-resume/${body.transferId}`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  upscaleTransferResume: async (body: { externalId: string }): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/upscale/transfer-resume/${body.externalId}`,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  weltradeLoginSecureUser: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/weltrade/login-secure`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  weltradeGetPayment: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
         "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/weltrade-payment-get`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  weltradeSavePayment: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
         "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/weltrade-payment-save`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  processorList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/admin/processor-list`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  processorRemove: async (body: IRemoveById): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/processor-remove`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  processorUpdateStatus: async (body: IRemoveById): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/processor-update-status`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
 
  fiatList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/fiat-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  fiatCreate: async (body: IFiatCreate): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/fiat-create`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  fiatEdit: async (body: IFiatEdit): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/fiat-edit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  fiatRemove: async (body: IRemoveById): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/fiat-remove`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  processorFiatRangeCreate: async (body: IProcessorFiatRange): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/processor-fiat-range-create`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  processorFiatRangeEdit: async (body: IProcessorFiatRange): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/processor-fiat-range-edit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  processorFiatRangeRemove: async (body: IRemoveById): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/processor-fiat-range-remove`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  processorFiatRangeList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/processor-fiat-range-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  transferCalculate: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/system/transfer-calculate`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  TransferCreate: async (body: ITransferCreate): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/transfer-create`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
 
  derivListDeposit: async (body: IAccountList): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/deriv-list-deposit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  depositDetail: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/deposit-detail`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
 
  depositUploadEvidence: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/system/deposit-upload-evidence`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  depositListAnyPic: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/system/deposit-list-any-pic`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  

  depositOpinionDetail: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/deposit-opinion-detail`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  depositOpinionSave: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/deposit-opinion-save`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  
  derivListDepositWait: async (body: IAccountList): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/deriv-list-deposit-wait`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  
  cashierAccountBankUpdateStatus: async (body: IUpdateStatus): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-account-update-status`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierCoinsMovements: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/coins-movements`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierGetFiatPrices: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-get-fiat-prices/${body.cashierId}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierUpdateFiatPrices: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-update-fiat-prices`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierUpdateFiatPricesNavbar: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-update-fiat-prices-navbar`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierSearchTransfer: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-search-transfer`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  
  chatTransferSaveMessage: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/chat-transfer/save-message`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  chatTransferListMessage: async (transferId: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/chat-transfer/get-message/${transferId}`,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  findChatId: async (transferId: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/chat-transfer/find-chatId/${transferId}`,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  notifyUserWannaBeCashier: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/notify-user-wannabe-cashier`,
        data: body
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  
  
  accountBankUpdateRemove: async (body: IUpdateStatus): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-bank-account-delete`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  systemVerifyCashierApodo: async (body: any): Promise<any> => {
    const apodo = (body?.apodo?.length || 0) > 0 ? body.apodo : '-'
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/system/verify-cashier-apodo/${apodo}`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  systemLoginHistory: async (body: any): Promise<any> => {

    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-auth-token": authToken(),
        },
        url: `${endPoint}/v1/system/login-history`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  
  adminDepositList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/deposit-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminDepositListSearch: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/deposit-list-search`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminUserExamined: async (id: string, startDate: string, endDate: string, bank: string, status: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-examined/${id}/${startDate}/${endDate}?bank=${bank}&status=${status}`,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  systemDepositUpdateStatus: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/system/deposit-update-status`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  systemViewNotifications: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/system/view-notifications`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  systemDispatchCronCancel: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/system/cron-time`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminDepositDetail: async (body: IDetailById): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/deposit-detail`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  derivCheckAccount: async (body: IDetailById): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/deriv-check-account`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminDepositTimeGet: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/deposit-time-get`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminDepositTimeSave: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/deposit-time-save`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  
  userDetailVerification: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/detail-verification`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
/*   userUploadPayment: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/upload-payment`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, */
  adminUserList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminUserListVerification: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-list-verification`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  systemUserDetail: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/system/user-detail`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  systemAppealList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/system/appeal-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  adminUserUpdateStatus: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-update-status`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  chatCreateMessage: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/chat-create-message`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  chatListMessage: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/chat-list-message`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  notificationCreate: async (body: ICreateNotification): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/notification-create`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  notificationList: async (body: IListNotification): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/notification-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  activateVerifyAccount: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/user/activate-verify-account`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  sendEmailVerifyAccount: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/send-email-verify-account`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userRecoverAccount: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken()
        },
        url: `${endPoint}/v1/user/recover-account`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userVerifyRecoverAccountCode: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken()
        },
        url: `${endPoint}/v1/user/verify-recover-account-code`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  transferUploadManyFiles: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/system/transfer-upload-many-files`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userUpdatePassword: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken()
        },
        url: `${endPoint}/v1/user/update-password`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminBlogCreateEdit: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/blog-create-edit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminBlogList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/blog-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminBlogUpdateStatus: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/blog-update-status`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminBlogRemove: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/blog-remove`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  webBlogList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/system/blog-list-website`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
 

  userRoleList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-role-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  userRoleUpdate: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-role-update`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userNotificationDelete: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/notification-delete`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 

 
  updateIsOnline: async (body: IRemoveById): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/update-is-online`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  listUserChat: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/list-user-chat`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  fetchFreeDollar: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/system/get-free-dollar`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  fetchCurrentDollar: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/system/get-current-dollar`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  /*userNotificationSeen  : async (body:any): Promise<any> => { 
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-ISF-Auth-Token': authToken()
        },
        url: `${endPoint}/v1/user/user-notification-seen`,
        data: body
      }).then((res) => {
        resolve(res)
      }).catch((err) => {
        console.log(err)
        reject(err)
      })
    })
  },*/

  getUserInfo: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/user/get-user-info`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  adminNotificationRead: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-notification-read`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userAddUpdateValidation: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/add-update-validation`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  userNotificationRead: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/user-notification-read`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  adminReports: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-reports`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  adminReportsProcessors: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-reports-processors/${body.startDate}/${body.endDate}/${body.status}`,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  adminUpdateVerification: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-update-verification`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  

  adminRemoveSomePic: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-remove-somepic`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  
  adminUpdateVerifiedIdentity: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-update-verifiedIdentity`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminProcessorSetFiat: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/processor-set-fiat`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userCheckVerifiedIdentity: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/user-check-verifiedIdentity`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userGetQuantities: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/user-get-quantities`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userFindMyCashier: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/find-my-cashier/${body.userId}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userChooseCashierList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/choose-cashier-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userNotifyScheduleSave: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/notify-schedule-save`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  userChooseCashierSet: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/choose-cashier-set`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  userUploadProfilePicture: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/upload-profile-picture`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  userCreateAppeal: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/create-appeal`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  updateLastConnection : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/update-last-connection`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  userGetCompletedTransfers: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/get-completed-transfers/${body.userId}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },   
  kycEmailNotification: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/kyc-email-notification`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  transferAccelerate: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/user/transfer-accelerate`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  adminSearchChatUser: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/search-chat-user`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  adminReadNotification: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-read-notification`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  adminNotificationDelete: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-notification-delete`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  cashierListProcessors: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-list-processors`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  calculatorListProcessors: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Access-Token": accessToken(),
        },
        url: `${endPoint}/v1/system/calculator-list-processors/${body?.cashierId}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierSwitchProcessors: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-switch-processors`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierListProcessorsRange: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-list-processors-range`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierSaveProcessorsRange: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-save-processors-range`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierDetail: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-detail`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierSearchClient: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-search-client`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierChangeClient: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/cashier-change-client`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierCoinsRequestSave : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-coin-request-save`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierCoinsRequestList : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-coin-request-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierCoinsRequestCancel : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-coin-request-cancel`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierCoinsRequestDetail : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-coin-request-detail`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierCoinsUploadPayment : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-coins-upload-payment`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  CashierCoinsGetPics : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-coins-get-pics/${body.id}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierConfigGet : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-config-get`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierWelcomeGet : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-welcome-list/${body.id}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierWelcomeUpdate : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-welcome-update`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  
  CashierNicknameSave : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-code-save`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierDescriptionTime : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/cashier/cashier-description-time`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  
  CashierByApodo : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken()
        },
        url: `${endPoint}/v1/system/cashier-by-apodo/${body.apodo}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierGetReviews : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken()
        },
        url: `${endPoint}/v1/cashier/cashier-get-reviews/${body.page}/${body.take}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierListTransfer : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/cashier-list-transfers/${body.cashierId}/${body.page}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierOpinions : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/user/cashier-opinions/${body.cashierId}/${body.page}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierGetCoins : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/cashier-get-coins/${body.cashierId}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  CashierGetAccountPayCoins : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/cahier-account-pay-coins/${body.processorId}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  
  cashierAccountCreate : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/cashier-account-create`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierAccountEdit : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/cashier-account-edit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierAccountRemove : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/cashier-account-remove`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierGetSchedule: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/cashier-get-schedule/${body.cashierId}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashiertSaveSchedule: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/cashier-save-schedule`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierGetSocialNetwork: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/social-network/${body.cashierId}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  cashierSaveSocialNetwork: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/social-network`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  cashierAccountList : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken()
        },
        url: `${endPoint}/v1/cashier/cashier-account-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminProfitList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-list-profit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminProfitSave: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-save-profit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminProfitDelete: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-delete-profit`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  AdminOpinionList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-transfer-opinion-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminOpinionStatusUpdate: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-transfer-opinion-status-update`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminRequestCoinsList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/request-coins-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminAccountPayCoinsSave: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/account-pay-coins-save`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminAccountPayCoinsList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/account-pay-coins-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminAccountPayCoinsDelete: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/account-pay-coins/${body.id}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminAccountPayCoinsUpdateStatus: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/account-pay-coins-update-status`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  AdminRequestCoinsUpdateStatus: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/request-coins-update-status`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },    
  AdminSetCoinsCashier: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/set-coins-cashier`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  AdminUserListLoggins: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-list-loggins`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },    
  AdminAppealFinish: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/appeal-finish`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  AdminGetHouseCoins: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/house-coins`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  AdminGetHouseCoinsMovements: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/house-coins-movements`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  AdminAllCashierCoins: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/all-cashier-coins`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  AdminWeltradeUpdateBalanceByAdmin: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/weltrade-update-balance-by-admin`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  AdminSendEmail: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-send-email-template`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminGetISFWeltradeBalance: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/weltrade-get-balance/${body.payment}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminGetUpscaleBalanceSummary: async (): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/upscale-get-balance`,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminGetUpscaleBalanceDetail: async (body: { environment: string; scope?: string }): Promise<any> => {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      if (body.scope) params.append("scope", body.scope);
      const query = params.toString();
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/upscale-get-balance/${body.environment}${query ? `?${query}` : ""}`,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminGetUpscaleTransferMap: async (depositId: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/upscale-transfer-map/${depositId}`,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminGetUpscaleTransferDetailByExternal: async (externalId: string): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/upscale-transfer-detail-by-external/${externalId}`,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminUpscaleUpdateBalanceByAdmin: async (body: { environment: string; balance: string }): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/upscale-update-balance-by-admin`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminUpscaleRunBalanceCron: async (): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/upscale-run-balance-cron`,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminWeltradeBalanceHistory: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      if (body.page !== undefined) params.append('page', body.page.toString());
      if (body.limit !== undefined) params.append('limit', body.limit.toString());
      if (body.status) params.append('status', body.status);
      
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/weltrade-balance-history?${params.toString()}`,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AdminWeltradeVerifyBalanceByDate: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      const params = new URLSearchParams();
      if (body.date) params.append('date', body.date);
      if (body.balance !== undefined) params.append('balance', body.balance.toString());
      
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/weltrade-verify-balance-by-date?${params.toString()}`,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  adminSaveVideo: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-save-video`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  adminUpdateImageVideo
  : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          "X-ISF-Auth-Token": authToken(),
        },
        url: `${endPoint}/v1/admin/admin-update-image-video`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  videoList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/system/video-list/${body.type}${body.status ? '/'+body.status : ''}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  getVideoPromotional: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/system/video-promotional`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
 
  fetchtWall: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/system/wall-content/${body.page}/${body.limit}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  videoUpdateStatus: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/admin/video-update-status`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  videoUpdateName: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/admin/video-update-name`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  videoUpdateViews: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/system/video-update-views`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  videoLike: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken()
        },
        url: `${endPoint}/v1/system/video-like`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  videoDelete: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/admin/video-delete`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },  
  videoPromotionalSectionSave: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/admin/videopromotional-section-save`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  videoPromotionalSectionList : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/admin/videopromotional-section-list`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  videoPromotionalCodeSave : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/admin/videopromotional-code-save`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  videoPromotionalCodeList : async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/admin/videopromotional-code-list/${body.sectionId}`,
        data: body,
      })
        .then((res) => {
          if (res.data.message === "Error en el token" || res.data.message === 'Token no encontrado') {
            getLogout();
          }
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  }, 
  completeFastRegister: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/weltrade/complete-fast-register`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  upscaleCompleteFastRegister: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/upscale/complete-fast-register`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },

  AppMobileProviderSignalList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      const skip = (body.page - 1) * 10;
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/app-mobile/providers/signals/${body.providerId}/${skip}`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AppMobileSignalCreate: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      // Si body es FormData, no establecer Content-Type (axios lo hará automáticamente)
      const isFormData = body instanceof FormData;
      const headers: any = {
        "X-ISF-Auth-token": authToken(),
      };
      
      if (!isFormData) {
        headers["Content-Type"] = "application/json";
      }
      
      axios({
        method: "POST",
        headers,
        url: `${endPoint}/v1/app-mobile/providers/signals/create`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AppMobileProviderList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/app-mobile/providers/list/0`,
        data: body,
      })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          console.log(err);
          reject(err);
        });
    });
  },
  AppMobileProviderSubscribersList: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
    
        url: `${endPoint}/v1/app-mobile//providers/subscribers/list/${body.providerId}/${body.page}`,
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  AppMobileProviderByDetail: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/app-mobile/providers/detail/${body.providerId}`,
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },

  AppMobileProviderSignalDelete: async (body: any): Promise<any> => {

    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/app-mobile/providers/signals/delete`,
        data: body,
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });

  },
  
  AppMobileSignalsGeneralFeed: async (body: any): Promise<any> => {

    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/app-mobile/user/signals/${body.userId}/${body.skip}`,
        data: body,
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });

  },
  AppMobileSusbcribersList: async (body: any): Promise<any> => {

    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/app-mobile/susbcribers/list/${body.skip}`,
        data: body,
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });

  },

  chatGTPImage: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/app-mobile/chatgpt/send-image`,
        data: body,
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },

  chatGTPGenerateAudio: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/app-mobile/chatgpt/text-to-speech`,
        data: body,
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  AppMobileSignalUploadImage: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/app-mobile/signal/upload-image`,
        data: body,
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },
  AppMobileSignalIA: async (body: any): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/app-mobile/signal/ia/${body.signalId}`,
      }).then((res) => {
        resolve(res);
      }).catch((err) => {
        reject(err);
      });
    });
  },

  WebappGetNotificationSettings: async (body: { token: string }): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "GET",
        headers: { "Content-Type": "application/json" },
        url: `${endPoint}/v1/app-mobile/webapp/notification-settings`,
        params: { token: body.token },
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  WebappUpdateNotificationSettings: async (body: {
    token: string;
    emailOnSignalCreate?: boolean;
    emailOnSignalUpdate?: boolean;
    pushOnSignalCreate?: boolean;
    pushOnSignalUpdate?: boolean;
    email?: boolean;
    push?: boolean;
    sms?: boolean;
  }): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        url: `${endPoint}/v1/app-mobile/webapp/update-notification-settings`,
        data: body,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  WebappUnsubscribeEmailSignals: async (body: { token: string }): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: { "Content-Type": "application/json" },
        url: `${endPoint}/v1/app-mobile/webapp/unsubscribe-email-signals`,
        data: body,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  RequestDeleteAccount: async (body: { email: string }): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/user/request-delete-account`,
        data: body,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  ConfirmDeleteAccount: async (body: { email: string; code: string }): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-access-token": accessToken(),
        },
        url: `${endPoint}/v1/user/confirm-delete-account`,
        data: body,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  AdminGetUserNotificationSettings: async (body: {
    email?: string;
    userId?: string;
  }): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-notification-settings`,
        data: body,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  AdminUpdateUserNotificationSettings: async (body: {
    email?: string;
    userId?: string;
    emailOnSignalCreate?: boolean;
    emailOnSignalUpdate?: boolean;
    pushOnSignalCreate?: boolean;
    pushOnSignalUpdate?: boolean;
    push?: boolean;
    sms?: boolean;
  }): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-notification-settings-update`,
        data: body,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },

  AdminGetUserDevices: async (body: {
    email?: string;
    userId?: string;
  }): Promise<any> => {
    return new Promise((resolve, reject) => {
      axios({
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-ISF-Auth-token": authToken(),
        },
        url: `${endPoint}/v1/admin/user-devices`,
        data: body,
      })
        .then((res) => resolve(res))
        .catch((err) => reject(err));
    });
  },
  
};

export default APIService;
